import styled from "styled-components";

export const ReportsComponentContainer = styled.div`
  display: grid;
  height: 100%;
  grid-template-rows: 40px 40px repeat(2, 1fr);
  row-gap: 50px;
`;
